import { ReactNode } from "react";

import { Container, Stack, Center, Heading } from "@chakra-ui/react";

interface CenteredLayoutProps {
  children: ReactNode;
  maxW?: string;
}

export const CenteredLayout = ({ children, maxW = "md" }: CenteredLayoutProps) => {
  return (
    <Container maxW={maxW} py={{ base: "12", md: "24" }}>
      <Stack gap="8">
        <Stack gap="6">
          <Center fontSize="6xl">🧠</Center>
          <Center>
            <Heading size={{ base: "xs", md: "3xl" }}>DSI + IT = DSIT</Heading>
          </Center>
        </Stack>
        {children}
      </Stack>
    </Container>
  );
};
